import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { FaTimes } from 'react-icons/fa'
import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from 'react-icons/io'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  onPrev?: () => void
  onNext?: () => void
  showNavigation?: boolean
  children: React.ReactNode
  size?: 'default' | 'medium' | 'large'
  showCloseButton?: boolean
  disableOverlayClick?: boolean
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onPrev,
  onNext,
  children,
  showNavigation = false,
  size = 'default',
  showCloseButton = true,
  disableOverlayClick = false,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = '15px'
    } else {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }

    return () => {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleOverlayClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (!disableOverlayClick && e.target === e.currentTarget) {
      onClose()
    }
  }

  return ReactDOM.createPortal(
    <div
      className='fixed inset-0 z-50'
      onClick={handleOverlayClick}
      data-testid='modal-overlay'
    >
      <div className='absolute inset-0 bg-black/90' />
      <div className='relative h-full flex items-center justify-center px-4 sm:px-12'>
        {showNavigation && onPrev && onNext && (
          <>
            <button
              onClick={onPrev}
              className='absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-redpink/20 text-redpink p-2 rounded-full transition-all z-[60]'
              title='Image précédente'
            >
              <IoMdArrowDropleftCircle className='text-5xl' />
            </button>
            <button
              onClick={onNext}
              className='absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-redpink/20 text-redpink p-2 rounded-full transition-all z-[60]'
              title='Image suivante'
            >
              <IoMdArrowDroprightCircle className='text-5xl' />
            </button>
          </>
        )}
        <div
          className={`relative ${
            size === 'large'
              ? 'w-full sm:w-auto mx-0 sm:mx-4'
              : size === 'medium'
              ? 'max-w-lg mx-4'
              : 'max-w-md mx-4'
          }`}
          onClick={e => e.stopPropagation()}
          data-testid='modal-content'
        >
          {showCloseButton && (
            <button
              className='absolute -top-3 -right-3 text-white bg-redpink p-2 rounded-full hover:text-anthracite z-10'
              onClick={onClose}
            >
              <FaTimes />
            </button>
          )}
          <div className={`${size === 'large' ? '' : 'bg-white rounded-lg'}`}>
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default Modal
